import React from 'react';
import PromotionServicePage from './PromotionServicePage';

const TidalPromotionPage = () => {
  return (
    <PromotionServicePage
      platform="tidal"
      platformName="Tidal"
      iconColor="bg-blue-500"
      description="Augmentez votre présence sur Tidal, la plateforme haute qualité pour les audiophiles."
      metaTitle="Promotion Tidal - 35$ | AGRP BOX"
      metaDescription="Développez votre audience sur Tidal avec notre service de promotion professionnelle AGRP BOX."
      url="/promouvoir-tidal"
    />
  );
};

export default TidalPromotionPage;
